import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import Typography from '../Typography'
import RfButton from '../Rf-button'
import withTheme from '../styles/withTheme'

import './ModalHeader.scss'

const ModalHeader = forwardRef(function ModalHeader(props, ref) {
	const {
		children,
		className,
		onClose = props.defaultOnClose, // defaultOnClose prop is passed as an extra prop automatically
		...other
	} = props

	function handleClose() {
		typeof onClose === 'function' && onClose()
	}

	return (
		<div ref={ref} className={clsx('Vb-modal-header', className)} {...other}>
			<Typography component="h2" variant="h4" style={{ width: '100%' }}>
				{children}
			</Typography>
			<RfButton icon="close2" color="dark" variant="link" IconProps={{ size: 1.5 }} className="Vb-btn-close" onClick={handleClose} />
		</div>
	)
})

export default withTheme('Vb-modal-header')(ModalHeader)

ModalHeader.propTypes = {
	/**
	 * Modal children, usually the included sub-components.
	 */
	children: PropTypes.node,
	/**
	 * Callback fired when the component requests to be closed.
	 *
	 * @param {object} event The event source of the callback.
	 * @default defaultOnClose (prop is passed as an extra prop automatically)
	 */
	onClose: PropTypes.func
}
